export const isEnabled = (value) =>
  value === true || value === 1 || value === "1";
